// Plan 1a Welle 2 (SPEC-GEMEINSAM GB-01 „Soll, Welle 2“ Punkt 1, Regel G-08): die Unterseiten der Einstellungen laden nicht
// erst mit dem Klick. Einmal je Sitzung holt vorladen() die Module, die App.tsx verzögert einbindet – im Leerlauf nach der
// Anmeldung (App.tsx) und beim Öffnen des Kontomenüs (components/UserMenu.tsx). Der Browser hält sie danach bereit; der
// Ersatz beim Nachladen (ladeErsatz.tsx) ist dann nur noch kurz zu sehen. Scheitert das Vorladen (kein Netz), bleibt es
// still: der Klick lädt wie bisher.

type Lader = () => Promise<unknown>;

/** Die Module hinter den Einträgen des Kontomenüs und den Bereichen des Pop-ups (dieselben wie in App.tsx). */
export const MODULE: readonly Lader[] = [
  () => import('./Unterseiten'),
  // die Seite „Präferenzen“ (PF-205-2), eigener Baustein wie in App.tsx; mit Endung wegen praeferenzen.ts
  () => import('./Praeferenzen.tsx'),
  () => import('../AccountAccess'),
  () => import('../../administration/organization/OrganisationsBereich'),
  () => import('../../administration/Administration'),
];

/** Ein Schalter, der die Lader beim ersten Aufruf startet und danach nichts mehr tut. */
export function einmal(lader: readonly Lader[]): () => void {
  let gestartet = false;
  return () => {
    if (gestartet) return;
    gestartet = true;
    for (const lade of lader) void lade().catch(() => undefined);
  };
}

/** Lädt die Unterseiten einmal je Sitzung vor; jeder weitere Aufruf lädt nichts mehr. */
export const vorladen = einmal(MODULE);

/** Ruft vorladen auf, sobald der Browser Leerlauf meldet (ersatzweise nach einem kurzen Zeitgeber); gibt das Abbrechen zurück. */
export function vorladenImLeerlauf(): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const nummer = window.requestIdleCallback(() => vorladen(), { timeout: 4000 });
    return () => window.cancelIdleCallback(nummer);
  }
  const nummer = window.setTimeout(vorladen, 1500);
  return () => window.clearTimeout(nummer);
}
